module.exports = __webpack_public_path__ + "img/fwlcImg1.1e746184.png";